import { connect } from "react-redux";
import { createSelector } from "reselect";

import Event from "./Event";
import {
  fieldsSelector,
  showEstimatedQuantitiesSelector,
} from "../../../redux/settings";
export * from "./Event";

const getEventOffice = (event) => {
  if (event.purchaseOrder) {
    return event.purchaseOrder.office;
  } else if (event.job) {
    return event.job.office;
  } else if (event.bid) {
    return event.bid.office;
  } else {
    return null;
  }
};

const makeGetEventType =
  () =>
  (state, { eventId }) => {
    const event = state.events.events.find((e) => e.id === eventId);

    if (event.purchaseOrder || event.inventoryPurchaseOrder) {
      return "purchaseOrder";
    } else if (event.job) {
      return "job";
    } else if (event.bid) {
      return "bid";
    }
    if (
      event.customer ||
      event.datasheet ||
      event.appttype ||
      event.evttype == "appointments"
    ) {
      return "appointment";
    } else {
      return "none";
    }
  };

const colorMode = (state) => state.settings.color;

const colors = createSelector(
  colorMode,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case "jobStatus":
        return jobStatuses;
      case "office":
        return offices;
      default:
        return jobTypes;
    }
  }
);

const makeGetEvent = () =>
  createSelector(
    (state, { eventId }) => state.events.events.find((e) => e.id === eventId),
    colorMode,
    colors,
    (event, colorMode, colors) => {
      let eventWithColor = {
        ...event,
        office: getEventOffice(event),
      };

      if (event.job) {
        let color = null;
        switch (colorMode) {
          case "jobType":
            const jobType = colors.find(
              (jobType) => jobType.name === event.job.jobType
            );
            color = jobType ? jobType.color : null;
            break;
          case "office":
            const office = colors.find(
              (office) => event.job.office && office.id === event.job.office.id
            );
            color = office ? office.color : null;
            break;
          case "salesperson":
            const salesperson = event.job.salesperson;
            color = salesperson ? salesperson.calendarColor : null;
            break;
          default:
            const jobStatus = colors.find(
              (jobStatus) => jobStatus.value === event.job.status
            );
            color = jobStatus ? jobStatus.color : null;
            break;
        }
        eventWithColor.color = color;
      }

      return eventWithColor;
    }
  );

const makeMapStateToProps = () => {
  const getEvent = makeGetEvent();
  const getEventType = makeGetEventType();
  return (state, props) => ({
    event: getEvent(state, props),
    eventType: getEventType(state, props),
    fields: fieldsSelector(state),
    showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
  });
};

const mapDispatchToProps = {};

export default connect(makeMapStateToProps, mapDispatchToProps)(Event);
